import { render, staticRenderFns } from "./acceptRejectForm.vue.html?vue&type=template&id=37926b24&"
import script from "./acceptRejectForm.ts?vue&type=script&lang=ts&"
export * from "./acceptRejectForm.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports